import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import ShippingList from "./lists/shippingList";
import ShippingForm from "./forms/shippingForm";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {paramsSerializer, postData} from "../../utils/request";
import ComponentConfig from "../form/ComponentConfig";
import {Link} from "react-router-dom";
import urldecode from "locutus/php/url/urldecode";
import { withSnackbar } from 'notistack';
import Modal from "../layout/Modal";
import isEqual from "lodash-es/isEqual";
import {loadComponent} from "../../utils/components";
import {SelectButton} from "primereact/selectbutton";
import moment from "moment";
import TabContent from "../layout/TabContent";
import Tabs from "../layout/Tabs";
import ModalEditor from "./ModalEditor";
import Confirm from "../form/Confirm";

class NewButton extends React.Component {

    state = {
        isLoading: false,
        count: 0
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            !isEqual(this.props.businessComponent.values[this.props.businessComponent.componentConfig.idfield], prevProps.businessComponent.values[prevProps.businessComponent.componentConfig.idfield])
            ||
            !isEqual(this.props.businessComponent.componentConfig.componentname, prevProps.businessComponent.componentConfig.componentname)
        ) {
            this.load();
        }
    }

    load = async () => {
        this.setState({
            isLoading: true, count: null
        }, () => {
            if (this.props.businessComponent) {
                this.loadShippings = loadComponent("componentlist", {
                    component: "shipping",
                    itemsperpage: 1,
                    view: [this.props.componentConfig.idfield, "state"],
                    filter: [
                        {
                            field: "client_component",
                            value: this.props.businessComponent.componentConfig.componentname
                        }, {
                            field: "client_component_id",
                            value: this.props.businessComponent.values[this.props.businessComponent.componentConfig.idfield]
                        }, {
                            field: "state",
                            value: 3,
                            operator: "<="
                        }
                    ]
                });
                this.loadShippings.then((all) => {
                    this.setState({
                        count: all.items.length,
                        isLoading: false
                    });
                });
            } else {
                this.setState({
                    count: 0,
                    isLoading: false
                });
            }
        });
    }

    render() {
        if (this.state.isLoading || !!this.state.count) return null;
        return (
            <Button
                key={9}
                disabled={this.props.disabled || this.state.isLoading}
                color="default"
                onClick={this.props.onClick}
            >
                Új
            </Button>
        );
    }
}

class shippingEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            moneyrepository: null,
            currentTab: this.props.values[this.props.componentConfig.idfield] ? "expired" : "failed"
        }
    }


    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    deleteForm = async (event) => {
        await this.props.deleteForm(event);
        this.list && this.list.refresh();
        this.editor && this.editor.hide();
    }

    checkOrder = async () => {
        await this.props.processAction(async () => {
            return await postData({
                action: this.props.values.serviceprovider_type + '.checkOrder',
                tracking_id: this.props.values.tracking_id
            });
        });
    }

    personalpickupCompleted = async () => {
        await this.props.processAction(async () => {
            return await postData({
                action: 'personalpickup.shippingCompleted',
                tracking_id: this.props.values.tracking_id,
                moneyrepository: this.state.moneyrepository
            });
        });
    }

    shippingFailed = async () => {
        await this.props.processAction(async () => {
            return await postData({
                action: 'shipping.shippingFailed',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield]
            });
        });
    }

    shippingDelivered = async () => {
        await this.props.processAction(async () => {
            return await postData({
                action: 'shipping.shippingDelivered',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield]
            });
        });
    }

    packageReceived = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'personalpickup.packageReceived',
                id: this.props.values[this.props.componentConfig.idfield]
            });
            this.props.enqueueSnackbar('Sikeresen beérkeztetve!', {
                variant: 'success',
            });
            return response;
        });
    }

    bulkFailed = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'personalpickup.bulkFailed',
                failedShippings: this.props.values.failedShippings
            });
            this.props.setFormValues({});
            this.props.enqueueSnackbar('Sikeres visszaküldés', {
                variant: 'success',
            });
            return response;
        });
    }

    updateExpiresAt = async (expires_at) => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'shipping.update',
                data: {
                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                    expires_at
                }
            });
            this.props.reloadForm && this.props.reloadForm();
            return response;
        });
    }

    recalculatePrice = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'shipping.recalculatePrice',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield]
            });
            this.props.enqueueSnackbar('Szállítási díj újraszámolva!', {
                variant: 'success',
            });
            return response;
        });
    }

    render() {
        const props = {...this.props};
        const List = this.props.list || (this.props.failedActions ? Fragment : Box);
        const Editor = this.props.editor || (this.props.failedActions ? ModalEditor : BoxEditor);
        const actionButtons = [];
        const editorButtons = [];
        if (
            ["pickpackpoint","furgefutar","furgefutarpoint"].indexOf(this.props.values.serviceprovider_type) !== -1
            &&
            parseInt(this.props.values.state || "0") < 3
            &&
            this.props.values.tracking_id
        ) {
            editorButtons.push(
                <Button
                    key="checkOrder"
                    disabled={this.props.isLoading}
                    color="default"
                    className="pull-right"
                    onClick={this.checkOrder}
                >
                    Állapot lekérdezés
                </Button>
            );
        }

        let disabled = (props.values.state || "0") + "" !== "0";

        if (!props.businessComponent && this.props.values.client_component_type) {
            editorButtons.push(
                <ComponentConfig key="details" componentName={this.props.values.client_component_type}>
                    {(props) =>
                        <Link
                            className="btn btn-default pull-right"
                            to={"?" + urldecode(paramsSerializer({option: this.props.values.client_component_type, [props.componentConfig.idfield]: this.props.values.client_component_id}))}
                        >
                            Rendelés adatai
                        </Link>
                    }
                </ComponentConfig>
            );
        }

        if (this.props.values.state + "" === "0") {
            editorButtons.push(
                <Button
                    key="recalculatePrice"
                    disabled={this.props.isLoading}
                    color="warning"
                    className="pull-right"
                    onClick={this.recalculatePrice}
                >
                    Szállítási díj újraszámolása
                </Button>
            );
        }

        if (parseInt(this.props.values.state || "0") <= 2 && parseInt(this.props.values.state || "0") > 0) {
            editorButtons.push(
                <Confirm
                    key="shippingFailed"
                    disabled={this.props.isLoading}
                    theme={parseInt(this.props.values.state || "0") < 2 && parseInt(this.props.values.state || "0") > 0 ? "danger" : undefined}
                    color={parseInt(this.props.values.state || "0") < 2 && parseInt(this.props.values.state || "0") > 0 ? "danger" : "warning"}
                    className="pull-right"
                    timeout={3}
                    header="Biztos sikertelen?"
                    body={parseInt(this.props.values.state || "0") < 2 && parseInt(this.props.values.state || "0") > 0 ? "Már meg van rendelve a szállítás, kérlek beszélj a raktárral hogy ne adják át a futárnak!" : "Biztos sikertelen a szállítás?"}
                    acceptButton="Igen"
                    onAccept={this.shippingFailed}
                >
                    {parseInt(this.props.values.state || "0") >= 2 ? "Szállítás sikertelen" : "Szállítás megszakítása"}
                </Confirm>
            );
        }

        if (this.props.values.serviceprovider_type !== "personalpickup") {
            if (parseInt(this.props.values.state || "0") < 3 && parseInt(this.props.values.state || "0") > 0) {
                editorButtons.push(
                    <Confirm
                        key="shippingDelivered"
                        disabled={this.props.isLoading}
                        color="success"
                        className="pull-right"
                        timeout={3}
                        privileges={["shipping_completed"]}
                        header="Biztos sikeres?"
                        body="Biztos megkapta a csomagot?"
                        acceptButton="Igen"
                        onAccept={this.shippingDelivered}
                    >
                        Sikeres szállítás
                    </Confirm>
                );
            }
        }

        if (this.props.values.serviceprovider_type === "personalpickup") {
            if (this.props.values.cod_amount <= 0 && this.props.values.state + "" === "2") {
                editorButtons.push(
                    <Button
                        key="personalpickupCompleted"
                        disabled={this.props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.personalpickupCompleted}
                    >
                        Átvette
                    </Button>
                );
            }
            if (this.props.values.state + "" === "1" && this.props.values.status + "" === "30") {
                editorButtons.push(
                    <Button
                        key="packageReceived"
                        disabled={this.props.isLoading}
                        color="success"
                        className="pull-right"
                        onClick={this.packageReceived}
                    >
                        Beérkezett
                    </Button>
                );
            }
        }
        if (this.props.failedActions) {
            actionButtons.push(
                <Button
                    key="bulkFailed"
                    disabled={this.props.isLoading || !Object.keys(this.props.values.failedShippings || {}).length}
                    color="primary"
                    className="pull-right"
                    onClick={this.bulkFailed}
                >
                    Csomag(ok) lezárása
                </Button>
            );
        }
        props.filter = Array.isArray(props.filter) ? [...props.filter] : (props.filter ? [props.filter] : []);
        if (props.businessComponent) {
            props.filter = [
                ...props.filter, ...[
                    {
                        field: "client_component",
                        value: props.businessComponent.componentConfig.componentname
                    }, {
                        field: "client_component_id",
                        value: props.businessComponent.values[props.businessComponent.componentConfig.idfield]
                    }
                ]
            ];
            if (!this.props.disable) {
                actionButtons.push(
                    <NewButton
                        key={9}
                        businessComponent={this.props.businessComponent}
                        disabled={props.isLoading}
                        componentConfig={this.props.componentConfig}
                        onClick={this.pristineForm}
                    />
                );
                editorButtons.push(
                    <Button
                        key={10}
                        disabled={!props.dirty || props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>
                );
                if (parseInt(this.props.values.state || "0") === 0) {
                    editorButtons.push(
                        <Button
                            key={11}
                            disabled={!this.props.values[this.props.componentConfig.idfield] || props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.deleteForm}
                        >
                            Törlés
                        </Button>
                    );
                }
            } else if (!disabled) {
                editorButtons.push(
                    <Button
                        key={12}
                        disabled={!props.dirty || props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>
                );
            }
        } else if(props.pos !== undefined) {
            props.filter = [
                ...props.filter, ...[
                    {
                        field: "serviceprovider_type",
                        value: "personalpickup"
                    },
                    {
                        field: "location",
                        value: props.pos.location.id
                    },
                ]
            ];
        }

        if (this.props.failedActions) {
            if ((this.props.values.failedType || 'all') === 'selected') {
                props.filter = [
                    ...props.filter, ...[{field: "id", value: Object.keys(this.props.values.failedShippings || {}).length ? Object.keys(this.props.values.failedShippings) : [-1], operator: "in"}]
                ];
            }
        }

        disabled = disabled || this.props.isLoading;

        return (
            <Fragment>
                <List
                    {...props}
                    collapsed={this.props.failedActions ? undefined : (props.collapsed || false)}
                    theme="default"
                    header={props.pos !== undefined ? "Csomag átadások/Személyes átvételek" : "Szállítások"}
                    footer={actionButtons}
                >
                    {
                        this.props.failedActions && this.state.currentTab === "failed" ? <div className="pull-right tab-extra"><SelectButton
                            value={this.props.values.failedType || 'all'}
                            options={[
                                {label: 'Összes', value: 'all'},
                                {label: 'Kiválaszottak', value: 'selected'}
                            ]}
                            onChange={(e) => this.props.setFieldValue("failedType", e.value)}
                        /></div> : null
                    }
                    {
                        this.props.failedActions ?
                            <Fragment>
                                <Tabs
                                    theme="default"
                                    currentTab={this.state.currentTab}
                                    onTabChange={(currentTab) => {
                                        if (currentTab === "expired") {
                                            this.props.setFormValues({});
                                        }
                                        this.setState({currentTab});
                                    }}
                                >
                                    <TabContent
                                        tabLabel="Átadandó csomagok"
                                        tabName="shipping"
                                        disabled={Object.keys(this.props.values.failedShippings || {}).length}
                                    >
                                        <ShippingList
                                            ref={(el) => this.list = el}
                                            {...props}
                                            gridid="shippingShippingList"
                                            failedActions={false}
                                            pageSize={this.props.failedActions ? 15 : 5}
                                            loadForm={this.loadForm}
                                            filter={[
                                                {
                                                    field: "state",
                                                    value: 2
                                                },
                                                ...props.filter
                                            ]}
                                        />
                                    </TabContent>
                                    <TabContent
                                        tabLabel="Lejárt csomagok"
                                        tabName="expired"
                                        disabled={Object.keys(this.props.values.failedShippings || {}).length || this.props.values[this.props.componentConfig.idfield]}
                                    >
                                        <ShippingList
                                            ref={(el) => this.list = el}
                                            {...props}
                                            gridid="expiredShippingList"
                                            failedActions={false}
                                            pageSize={this.props.failedActions ? 15 : 5}
                                            loadForm={this.loadForm}
                                            filter={[
                                                {
                                                    field: "expires_at",
                                                    value: moment().format("YYYY-MM-DD"),
                                                    operator: "<"
                                                },
                                                {
                                                    field: "state",
                                                    value: 2
                                                },
                                                ...props.filter
                                            ]}
                                        />
                                    </TabContent>
                                    <TabContent
                                        tabLabel="Át nem vett csomagok"
                                        tabName="failed"
                                        disabled={Object.keys(this.props.values.failedShippings || {}).length || this.props.values[this.props.componentConfig.idfield]}
                                        footer={actionButtons}
                                    >
                                        <ShippingList
                                            {...props}
                                            gridid="failedShippingList"
                                            pageSize={this.props.failedActions ? 15 : 5}
                                            failedActions={this.props.failedActions ? (failedShippings) => {
                                                this.props.setFieldValue("failedShippings", failedShippings);
                                            } : null}
                                            failedSelection={this.props.values.failedShippings || {}}
                                            loadForm={null}
                                            selection={null}
                                            filter={[
                                                {
                                                    field: "status",
                                                    value: 30
                                                },
                                                {
                                                    field: "state",
                                                    value: 4
                                                },
                                                ...props.filter
                                            ]}
                                        />
                                    </TabContent>
                                    <TabContent
                                        tabLabel="Átadott csomagok"
                                        tabName="completed"
                                        disabled={Object.keys(this.props.values.failedShippings || {}).length || this.props.values[this.props.componentConfig.idfield]}
                                    >
                                        <ShippingList
                                            {...props}
                                            gridid="completedShippingList"
                                            pageSize={this.props.failedActions ? 15 : 5}
                                            failedActions={false}
                                            loadForm={null}
                                            selection={null}
                                            filter={[
                                                {
                                                    field: "status",
                                                    value: 30
                                                },
                                                {
                                                    field: "state",
                                                    value: 3
                                                },
                                                ...props.filter
                                            ]}
                                        />
                                    </TabContent>
                                </Tabs>
                            </Fragment>
                        :
                        <ShippingList
                            ref={(el) => this.list = el}
                            {...props}
                            loadForm={this.loadForm}
                        />
                    }
                </List>
                {(this.state.currentTab === "shipping" || (!this.props.failedActions || (this.props.failedActions && this.state.currentTab === "expired" && this.props.values[this.props.componentConfig.idfield]))) && <Editor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={props.pos !== undefined ? "Csomag átadás/Személyes átvétel adatai" : "Szállítás adatai"}
                    footer={editorButtons}
                >
                    <ShippingForm
                        ref={(form) => this.form = form}
                        {...props}
                        updateExpiresAt={this.updateExpiresAt}
                        setMoneyRepository={(moneyrepository) => this.setState({moneyrepository})}
                        moneyrepository={this.state.moneyrepository}
                        personalpickupCompleted={this.personalpickupCompleted}
                        disabled={disabled}
                    />
                </Editor>}
            </Fragment>
        );
    }
}

export default withSnackbar(createEditor({
    componentName: "shipping",
    WrappedComponent: shippingEditor,
    props: {
        componentActions: (action, data, params) => {
            data = {...data};
            delete data.agent;
            if (data.location && data.location instanceof Object) {
                data.location = data.location.id;
            }
            if (data.agent) {
                data.agent = data.agent.id;
            }
            delete data.methodname;
            return {action,data,params};
        }
    }
}));
